import { render } from "./TradingPage.vue?vue&type=template&id=26d74ee5&scoped=true"
import script from "./TradingPage.vue?vue&type=script&lang=js"
export * from "./TradingPage.vue?vue&type=script&lang=js"

import "./TradingPage.vue?vue&type=style&index=0&id=26d74ee5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d74ee5"]])

export default __exports__